<template>
  <div class="managingPeople hp100" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <el-button
            plain
            class="add-column-btn"
            @click="gotoDetail(null)"
            type="primary"
          >
            <i class="el-icon-plus fw900 f16"></i> 新增</el-button
          >
          <el-button
            plain
            class="add-column-btn"
            @click="showSortDialog"
            type="primary"
          >
            品项分类排序</el-button
          >
        </el-col>
        <el-col>
          <div class="flex align-center justify-end header-search-box">
            <el-input
              placeholder="查询条件"
              clearable
              v-model="searchInput"
              class="header-search-input ml10"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="textblue searchBtn"
                @click="search()"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style="margin-top: 20px">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
            >
              <el-table-column
                label="序号"
                type="index"
                align="center"
                width="80px"
              >
                <!-- <template slot-scope="scope">
                  <span>{{ scope.row.index + 1 }}</span>
                </template> -->
              </el-table-column>
              <el-table-column label="id" align="center" prop="id">
                <template slot-scope="scope">
                  <span>{{ scope.row.id }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="商家编码" align="center"  prop="商家编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商家名称" align="center"  prop="商家名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品类别编码" align="center"  prop="产品类别编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.categoryCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="产品类别名称"
                align="center"
                prop="产品类别名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.categoryName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="大类编码" align="center"  prop="大类编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.classCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="大类名称" align="center"  prop="大类名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.className }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="部门编码" align="center"  prop="部门编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.deptCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="部门名称" align="center"  prop="部门名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.deptName }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="线上是否可见"
                align="center"
                prop="是否可见"
              >
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.isVisible }}</span> -->
                  <span v-if="scope.row.isVisible == '1'">可见</span>
                  <span v-else-if="scope.row.isVisible == '0'">不可见</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="备注" align="center"  prop="备注" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.remark }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="排序" align="center"  prop="排序" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.seq }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="连锁编码" align="center"  prop="连锁编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.groupCode }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="连锁名称" align="center" prop="连锁名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.groupName }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-edit orange f16"
                      @click="gotoDetail(scope.row.id, scope.row.userCode)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-delete orange f16 ml20"
                      @click="del(scope.row.id)"
                    ></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table> </el-row
        ></el-scrollbar>
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisible"
      width="400px"
      center
    >
      <el-form
        :model="merchantProductCategory"
        ref="merchantProductCategory"
        label-width="100px"
        class="merchantProductCategory"
        size="mini"
      >
        <el-form-item label="产品类别名称" prop="categoryName">
          <el-input
            style="width: 220px"
            v-model="merchantProductCategory.categoryName"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="是否可见" prop="isVisible">
          <el-select
            style="width: 220px"
            v-model="merchantProductCategory.isVisible"
            placeholder="请选择"
          >
            <el-option
              v-for="item in visibleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-row>
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="排序" prop="seq">
              <el-input v-model="merchantProductCategory.seq"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain class="bbox" @click="cancelSave" type="primary">
          取 消
        </el-button>
        <el-button type="primary" class="add-column-btn" @click="submitForm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="品项分类排序"
      :visible.sync="sortDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      style="height: 800px"
    >
      <el-table :data="tableData1" height="250" border style="width: 100%">
        <el-table-column prop="categoryName" label="产品类别名称">
        </el-table-column>
        <el-table-column prop="" label="当前排序">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.seq"
              filterable
              placeholder="请选择"
              @change="changeSort(scope.row)"
            >
              <el-option
                v-for="item in sortOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page.sync="queryInfo1.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo1.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      tableData1: [],
      sortOptions: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: "",
          merchantCode: ""
        }
      },
      queryInfo1: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: "",
          merchantCode: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      dialogFormVisible: false,
      title: "新增品项分类",
      merchantProductCategory: {
        merchantCode: localStorage.getItem("merchantCode"),
        merchantName: localStorage.getItem("merchantName")
      },
      visibleOptions: [
        {
          value: "0",
          label: "不可见"
        },
        {
          value: "1",
          label: "可见"
        }
      ],
      sortDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    showSortDialog() {
      this.sortDialogVisible = true;
      this.getListData1();
    },
    //条件查询
    search() {
      this.queryInfo.condition.id = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange1(newSize) {
      this.queryInfo1.pageSize = newSize;
      this.getListData1();
    },
    // 监听 页码值 改变事件
    handleCurrentChange1(newSize) {
      this.queryInfo1.currPage = newSize;
      this.getListData1();
    },
    changeSort(row) {
      let that = this;
      // 排序
      console.log(row);
      console.log(row.seq);
      // return;
      this.$http
        .post("/merchantProductsCategory/updateCategorySeq", {
          id: row.id,
          seq: row.seq
        })
        .then(response => {
          console.log(response);
          that.getListData();
          that.getListData1();
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      if (id) {
        this.title = "编辑品项分类";
        this.loadBaseInfo(id);
      } else {
        this.title = "新增品项分类";
        this.merchantProductCategory = {
          merchantCode: localStorage.getItem("merchantCode"),
          merchantName: localStorage.getItem("merchantName")
        };
      }
      this.dialogFormVisible = true;
      // this.$router.push({
      //   path: "/merchantProductCategory/details",
      //   query: {
      //     id: id,
      //     currPage: that.queryInfo.currPage,
      //     pageSize: that.queryInfo.pageSize,
      //   },
      // });
    },
    cancelSave() {
      this.dialogFormVisible = false;
      this.merchantProductCategory = {
        merchantCode: localStorage.getItem("merchantCode"),
        merchantName: localStorage.getItem("merchantName")
      };
    },
    submitForm() {
      var that = this;
      if (!this.merchantProductCategory.categoryName) {
        this.$message.error({
          title: "提示",
          message: "类别名称不能为空",
          showClose: true
        });
        return;
      }
      // if (!this.merchantProductCategory.isVisible) {
      //   this.$message.error({
      //     title: "提示",
      //     message: "是否可见不能为空",
      //     showClose: true
      //   });
      //   return;
      // }
      that.$http
        .post("/merchantProductsCategory/save", that.merchantProductCategory)
        .then(function(response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: "提示",
              message: "保存成功",
              showClose: true
            });
            that.dialogFormVisible = false;
            // that.$router.push("/merchantProductCategory");
          } else {
            that.$message.error({
              title: "提示",
              message: "保存失败",
              showClose: true
            });
          }
          that.getListData();
        });
    },
    loadBaseInfo(id) {
      let that = this;
      that.$http
        .post("/merchantProductsCategory/queryOne", { id })
        .then(function(response) {
          if (response.data.code == 200) {
            that.merchantProductCategory = response.data.data;
          }
        });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantProductsCategory/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.merchantCode = JSON.parse(
        localStorage.getItem("merchantCode")
      );
      that.$http
        .post("/merchantProductsCategory/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    getListData1() {
      // 获取列表
      var that = this;
      that.queryInfo1.condition.merchantCode = JSON.parse(
        localStorage.getItem("merchantCode")
      );
      that.$http
        .post("/merchantProductsCategory/list", that.queryInfo1)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo1.currPage = response.data.data.currPage;
            that.tableData1 = response.data.data.data;
            if (that.total !== 0) {
              that.sortOptions = [];
              for (let i = 1; i <= that.total; i++) {
                that.sortOptions.push({
                  label: i,
                  value: i
                });
              }
            }
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.orange {
  color: #f59a23;
}

.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;

    .el-select > .el-input {
      width: 200px;
    }

    .header-search-box .header-search-input {
      width: 325px;
    }

    input::placeholder {
      font-size: 12px;
    }

    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      // background: #f59a23;
      // color: #fff;
      // border-color: #f59a23;
      z-index: 102;
    }

    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}

.el-button.add-column-btn {
  background: #f59a23;
  color: #fff;
  border-color: #f59a23;
}
.el-button.bbox {
  border-color: #f59a23;
  color: #fff;
  background: #f0cd7c;
}
.el-button.bbox:hover {
  background: #f59a23;
  border-color: #f59a23;
}

/deep/.el-scrollbar__view {
  min-width: 100%;
}

/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}

/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
// /deep/ .el-button {
//   background: #f59a23;
//   color: #fff;
//   border-color: #f59a23;
// }

// /deep/ .el-button:hover {
//   background: #f59a23;
//   color: #fff;
//   border-color: #f59a23;
// }
</style>
